export type QuerySize = number | string;

export const DEFAULT_DESKTOP_MIN_WIDTH: QuerySize = `${1025 / 16}em`;
export const DEFAULT_TABLET_MIN_WIDTH: QuerySize = `${768 / 16}em`;
export const DEFAULT_TABLET_MAX_WIDTH: QuerySize = `${1024 / 16}em`;
export const DEFAULT_PHONE_MAX_WIDTH: QuerySize = `${767 / 16}em`;
export const DEFAULT_DESKTOP_LARGE_MIN_WIDTH: QuerySize = `${1280 / 16}em`;
